import gql from 'graphql-tag';

const employeeOptionFragment = gql`
fragment EmployeeOptionFragment on Employee {
    id,
    account {
        id
        firstName
        lastName
    }
}
`;

export const GET_ORDERS = gql`
    query Orders($offset: Int, $limit: Int, $filters: OrderFilters) {
     orders(offset: $offset, limit: $limit, filters: $filters) {
            id
            createdUtc
            orderState
            name
            orderNumber
            bills {
                id
                billState
                total
                total
                dicountedTotalValue
                roundedPrice
            }
            openedBy {
                account {
                    id
                    firstName
                    lastName
                    imageUrl
                }
            }
            orderLines {
                id
                price
                orderLineState
                billId
                tax {
                    id
                    rate
                }
                quantity
                product {
                    id
                    name
                    priceSell
                    tax {
                        id
                        rate
                    }
                }
            }
            place {
                id
                name
            }
        }
    }
`;

export const GET_ORDER = gql`
    query Order($id: String!) {
        order(id: $id) {
            id
            createdUtc
            orderState
            name
            orderNumber
            openedBy {
                account {
                    id
                    firstName
                    lastName
                    imageUrl
                }
            }
            closedBy {
                account {
                    id
                    firstName
                    lastName
                    imageUrl
                }
            }
            orderLines {
                id
                price
                unitPrice
                quantity
                discountedPrice
                discountedUnitPrice
                orderLineState
                tax {
                    id
                    rate
                }
                product {
                    id
                    name
                    tax {
                        id
                        rate
                    }
                }
                billId
            }
            bills {
                id
                issuedUtc
                billNumber
                total
                dicountedTotalValue
                roundedPrice
                billState
            }
            place {
                id
                name
            }
        }
    }
`;

const sectionOptionFragment = gql`
fragment SectionsOptionFragment on Section {
    name,
    id,
    places {
        id
        name
    }
}
`;

export const GET_FILTERS_OPTIONS = gql`
    query GetOrderFiltersOptions{
        sections {
            ...SectionsOptionFragment
        }
        employees {
            ...EmployeeOptionFragment
        }
    }
    ${sectionOptionFragment}
    ${employeeOptionFragment}
`;

export const GET_TIMELINE_DATA = gql`
        query Timeline($orderId: String!) {
            timeline(orderId: $orderId)
    }    
`;